/* Torpion – Mobile-Navigation (Schublade + Drill-down, Gesten, Haptik) */
(function(){
  "use strict";
  var root=document.getElementById("mnav");
  var burger=document.getElementById("burger");
  if(!root||!burger) return;

  /* ans Body-Ende verschieben: kein Einfluss durch backdrop-filter/sticky des Headers */
  document.body.appendChild(root);

  var drawer=root.querySelector(".mnav-drawer");
  var rootPanel=root.querySelector('[data-panel="root"]');
  var current=null; /* aktives Unter-Panel */
  var reduce=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Haptik ---------- */
  var hapticLabel=null;
  (function(){
    /* iOS Safari 18+: Klick auf ein <input switch> löst eine System-Haptik aus */
    try{
      var l=document.createElement("label");
      l.setAttribute("aria-hidden","true");
      l.style.cssText="position:fixed;left:-9999px;top:0;width:1px;height:1px;opacity:0;pointer-events:none";
      var i=document.createElement("input");
      i.type="checkbox"; i.setAttribute("switch",""); i.tabIndex=-1;
      l.appendChild(i); document.body.appendChild(l); hapticLabel=l;
    }catch(e){}
  })();
  function tick(strong){
    try{
      if(navigator.vibrate){ navigator.vibrate(strong?14:8); return; }
      if(hapticLabel) hapticLabel.click();
    }catch(e){}
  }

  /* ---------- Scroll-Sperre ---------- */
  var scrollY=0;
  function lock(){
    scrollY=window.scrollY||0;
    document.documentElement.classList.add("mnav-lock");
    document.body.style.top=(-scrollY)+"px";
  }
  function unlock(){
    document.documentElement.classList.remove("mnav-lock");
    document.body.style.top="";
    window.scrollTo(0,scrollY);
  }

  /* ---------- Öffnen / Schließen ---------- */
  function open(){
    if(root.classList.contains("is-open")) return;
    resetPanels(true);
    root.hidden=false;
    root.setAttribute("aria-hidden","false");
    lock();
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.add("is-open"); }); });
    burger.setAttribute("aria-expanded","true");
    tick(true);
    setTimeout(function(){ var f=root.querySelector(".mnav-x"); f&&f.focus({preventScroll:true}); },320);
  }
  function close(silent){
    if(!root.classList.contains("is-open")) return;
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden","true");
    burger.setAttribute("aria-expanded","false");
    drawer.style.transform=""; drawer.style.transition="";
    if(!silent) tick();
    unlock();
    setTimeout(function(){ if(!root.classList.contains("is-open")){ root.hidden=true; resetPanels(true);} }, reduce?0:480);
    burger.focus({preventScroll:true});
  }

  /* ---------- Unter-Panels ---------- */
  function resetPanels(instant){
    root.querySelectorAll(".mnav-panel.is-active").forEach(function(p){ if(p!==rootPanel) p.classList.remove("is-active"); });
    rootPanel.classList.remove("is-behind");
    current=null;
  }
  function openPanel(id){
    var p=root.querySelector('[data-panel="'+id+'"]');
    if(!p) return;
    p.scrollTop=0;
    p.classList.add("is-active");
    rootPanel.classList.add("is-behind");
    current=p;
    tick();
    setTimeout(function(){ var b=p.querySelector(".mnav-back"); b&&b.focus({preventScroll:true}); },260);
  }
  function back(){
    if(!current) return;
    var id=current.getAttribute("data-panel");
    current.classList.remove("is-active");
    current.style.transform=""; current.style.transition="";
    rootPanel.classList.remove("is-behind");
    rootPanel.style.transform=""; rootPanel.style.opacity="";
    current=null;
    tick();
    var t=rootPanel.querySelector('[data-mnav-open="'+id+'"]'); t&&t.focus({preventScroll:true});
  }

  /* ---------- Events ---------- */
  burger.addEventListener("click",function(e){ e.preventDefault(); root.classList.contains("is-open")?close():open(); });
  root.addEventListener("click",function(e){
    var t=e.target;
    if(t.closest("[data-mnav-close]")){ e.preventDefault(); close(); return; }
    var o=t.closest("[data-mnav-open]");
    if(o){ e.preventDefault(); openPanel(o.getAttribute("data-mnav-open")); return; }
    if(t.closest("[data-mnav-back]")){ e.preventDefault(); back(); return; }
    var a=t.closest("a[href]");
    if(a){ tick(); setTimeout(function(){ close(true); },250); }
  });
  document.addEventListener("keydown",function(e){
    if(!root.classList.contains("is-open")) return;
    if(e.key==="Escape"){ current?back():close(); }
    if(e.key==="Tab"){ /* Fokus in der Schublade halten */
      var scope=current||rootPanel;
      var f=[root.querySelector(".mnav-x")].concat([].slice.call(scope.querySelectorAll("a[href],button,input"))).filter(function(x){return x&&x.offsetParent!==null;});
      if(!f.length) return;
      var first=f[0], last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey&&document.activeElement===last){ e.preventDefault(); first.focus(); }
    }
  });
  window.addEventListener("resize",function(){ if(window.innerWidth>1100) close(true); });

  /* ---------- Wisch-Gesten ---------- */
  var sx=0, sy=0, dx=0, mode=null, w=0;
  drawer.addEventListener("touchstart",function(e){
    if(e.touches.length!==1) return;
    sx=e.touches[0].clientX; sy=e.touches[0].clientY; dx=0; mode=null; w=drawer.offsetWidth;
  },{passive:true});
  drawer.addEventListener("touchmove",function(e){
    var x=e.touches[0].clientX, y=e.touches[0].clientY;
    var ddx=x-sx, ddy=y-sy;
    if(mode===null){
      if(Math.abs(ddx)<8&&Math.abs(ddy)<8) return;
      if(Math.abs(ddy)>Math.abs(ddx)){ mode="scroll"; return; }
      if(current&&ddx>0) mode="back";
      else if(!current&&ddx<0) mode="close";
      else { mode="scroll"; return; }
    }
    if(mode==="close"){
      dx=Math.min(0,ddx);
      drawer.style.transition="none";
      drawer.style.transform="translate3d("+dx+"px,0,0)";
      root.style.setProperty("--mnav-fade",String(Math.max(0,1+dx/w)));
    } else if(mode==="back"){
      dx=Math.max(0,ddx);
      current.style.transition="none";
      current.style.transform="translate3d("+dx+"px,0,0)";
      rootPanel.style.transition="none";
      rootPanel.style.transform="translate3d("+(-0.3*w+0.3*dx)+"px,0,0)";
      rootPanel.style.opacity=String(Math.min(1,.35+.65*dx/w));
    }
  },{passive:true});
  function endTouch(){
    if(mode==="close"){
      drawer.style.transition=""; root.style.removeProperty("--mnav-fade");
      if(dx<-Math.min(90,w*.28)) close(); else { drawer.style.transform=""; }
    } else if(mode==="back"){
      current.style.transition=""; rootPanel.style.transition="";
      if(dx>Math.min(90,w*.28)){ back(); }
      else { current.style.transform=""; rootPanel.style.transform=""; rootPanel.style.opacity=""; }
    }
    mode=null; dx=0;
  }
  drawer.addEventListener("touchend",endTouch,{passive:true});
  drawer.addEventListener("touchcancel",endTouch,{passive:true});
})();
